import { getSchema, MergeField, MergeSchema } from '../../decorators';
import { ActivityEntityName } from '../../../../entities';

@MergeSchema({
    entity: ActivityEntityName.Employee,
    name: 'EmployeeMergeSchema',
})
export class EmployeeMergeData {

    @MergeField()
    _id: string;

    @MergeField()
    firstName: string;

    @MergeField()
    lastName: string;

    @MergeField()
    name: string;

    @MergeField()
    mobile: string;

    @MergeField()
    workPhone: string;

    @MergeField()
    email: string;

    @MergeField()
    jobTitle: string;

    @MergeField()
    tags: string;

    customFields: any;
}

export const EmployeeMergeSchema = getSchema(EmployeeMergeData);

export const contactMergeDataFromEmployee = (employee: EmployeeMergeData) => {
    return {
        _id: employee._id,
        name: employee.name,
        phone: employee.workPhone,
        mobile: employee.mobile,
        email: employee.email
    };
}